import {
  lazy,
  LazyLoadComponent,
} from "mhc-ui-components/dist/LazyLoadComponent";

import {IAppRoute} from "../../application/config/IAppRoute";
import {routeSignInWithInvitationPagePaths} from "./routeSignInWithInvitationPage.paths";

const SignInPage = lazy(() => import("../pages/SignInPage"));

export const routeSignInWithInvitationPage: IAppRoute = {
  ...routeSignInWithInvitationPagePaths,
  render: () => (
    <LazyLoadComponent>
      <SignInPage signInWithInvitation/>
    </LazyLoadComponent>
  ),
};
